import { render } from "./cage-personalinfo.vue?vue&type=template&id=c65e2d98"
import script from "./cage-personalinfo.vue?vue&type=script&lang=js"
export * from "./cage-personalinfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__